import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
// import { VendorInvitation } from '../pages/project/roles/roles.component';
import { CustomerRegistration } from '../pages/chatbot/customer-register-form/customer-register-form.component';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private apiUrl = environment.apiUrl;
  // private apiUrlAdmin = 'https://api.indiapicture.in/';
  private apiUrlAdmin='https://api.34.93.179.39.nip.io/'
  private vendorLoginUrl = environment.vendorLogin;
  // private aurl='http://localhost:8000/';

  constructor(private http: HttpClient) {}

  // Generic GET request
  get<T>(endpoint: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}${endpoint}`, { params });
  }
  getCustomer<T>(endpoint: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(`${this.apiUrlAdmin}${endpoint}`, { params });
  }

  // Generic POST request
  post<T>(endpoint: string, body: any, headers?: HttpHeaders): Observable<T> {
    return this.http.post<T>(`${this.apiUrl}${endpoint}`, body, { headers });
  }

  // Generic PUT request
  put<T>(endpoint: string, body: any): Observable<T> {
    return this.http.put<T>(`${this.apiUrl}${endpoint}`, body);
  }

  // Generic DELETE request
  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(`${this.apiUrl}${endpoint}`);
  }
  // In your ApiService
  patch<T>(url: string, body: any): Observable<T> {
    return this.http.patch<T>(`${this.apiUrl}${url}`, body);
  }

  addInvitation(invitation: any): Observable<any> {
    return this.http.post(`${this.apiUrl}vendors/invite`, invitation);
  }

  // ----------------register-------
  registerCustomer(data: CustomerRegistration): Observable<any> {
    // const { password, ...payload } = data;
    return this.http.post(`${this.apiUrl}customer/register`, data);
  }

  // api.service.ts

  vendorLogin<T>(body: any, headers?: HttpHeaders): Observable<T> {
    return this.http.post<T>(this.vendorLoginUrl, body, { headers });
  }
}
